/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Integrations_Runs_EmptyInputs */

const cs_integrations_runs_empty = /** @type {(inputs: Integrations_Runs_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zatím žádné běhy.`)
};

const en_integrations_runs_empty = /** @type {(inputs: Integrations_Runs_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No sync runs yet.`)
};

/**
* | output |
* | --- |
* | "No sync runs yet." |
*
* @param {Integrations_Runs_EmptyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const integrations_runs_empty = /** @type {((inputs?: Integrations_Runs_EmptyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Integrations_Runs_EmptyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_integrations_runs_empty(inputs)
	return cs_integrations_runs_empty(inputs)
});